import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { Howl } from 'howler';

const TranceContext = createContext();

export const useTrance = () => useContext(TranceContext);

export const TranceProvider = ({ children }) => {
  const [isTranceMode, setIsTranceMode] = useState(false);
  const soundRef = useRef(null);

  // Audio URL from artifacts
  const AUDIO_URL = "https://customer-assets.emergentagent.com/job_1486adc5-dbe8-46d5-a4c9-2e41785746c1/artifacts/slp7wlhb_AUD-20251023-WA0082.mp3";

  useEffect(() => {
    soundRef.current = new Howl({
      src: [AUDIO_URL],
      loop: true,
      volume: 0.8,
      html5: true, // Force HTML5 Audio to stream large files
      preload: true,
    });

    return () => {
      if (soundRef.current) {
        soundRef.current.unload();
      }
    };
  }, []);

  const toggleTranceMode = () => {
    setIsTranceMode(prev => {
      const newState = !prev;
      if (newState) {
        soundRef.current?.play();
        document.body.classList.add('trance-active');
      } else {
        soundRef.current?.pause();
        document.body.classList.remove('trance-active');
      }
      return newState;
    });
  };

  return (
    <TranceContext.Provider value={{ isTranceMode, toggleTranceMode }}>
      {children}
    </TranceContext.Provider>
  );
};
